import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useCreatePassword } from '@services/auth/mutations/useCreatePassword'

import { AuthLayout } from '../components/AuthLayout'
import { PasswordForm, PasswordFormValues } from '../components/PasswordForm'

export function CreatePassword() {
  const { t } = useTranslation('auth')
  const navigate = useNavigate()
  const location = useLocation()
  const token = new URLSearchParams(location.search).get('token') || ''

  const {
    mutate: createPassword,
    isPending,
    isSuccess
  } = useCreatePassword()

  useEffect(() => {
    if (isSuccess) navigate('/login')
  }, [isSuccess, navigate])

  const handleSubmit = (values: PasswordFormValues) =>
    createPassword({
      body: {
        token,
        password: values.password,
        password_confirmation: values.password_confirmation
      }
    })

  return (
    <AuthLayout
      title={t('createPassword.title')}
      subtitle={t('createPassword.text')}
      footer={
        <Link
          to="/login"
          className="font-semibold text-primary hover:underline"
        >
          {t('register.login')}
        </Link>
      }
    >
      <PasswordForm onSubmit={handleSubmit} isPending={isPending} />
    </AuthLayout>
  )
}
